module.exports = __webpack_public_path__ + "static/media/18import-43.89402221.xlsx";